<template>
  <v-card
    elevation=12
    class="mx-auto"    
  >
    <v-img v-if="photo"
      class="white--text align-end"
      height="200px"
      v-bind:src="photo"
    >
    </v-img>

    <v-card-title>{{title}}</v-card-title>
    <v-card-subtitle v-html="description"></v-card-subtitle>

    <!--<div>

      <v-card-text class="text--primary">
        <div v-html="description"></div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          :to="{ name: 'ChallengeDetail', params: { chid: data.chid }}"
          color="orange"
          text
        >
          Ver Ideas
        </v-btn>
      </v-card-actions>
    </div>-->
  </v-card>
</template>


<script>
  export default {
    name: 'Info',
    props: ['photo','title','description'],
    data: () => ({
    }),
    created() {
    },
    methods: {
    }
    
  }

  
</script>